import { useEffect, useState } from 'react';

import { useSearchParams } from 'react-router-dom';

import * as Aspiration from './components/AspirationRoot';
import { AspirationForm } from './components/AspirationForm';
import { initialState } from './utils/state';

export const AspirationPage = () => {
  const [params] = useSearchParams();
  const [showForm, setShowForm] = useState(initialState.showForm);

  const aspirationId = params.get('aId');

  useEffect(() => {
    if (!aspirationId) setShowForm(false);
  }, [aspirationId]);

  return (
    <Aspiration.Root className="h-full space-y-6 py-6">
      {!showForm ? (
        <>
          <div className="flex w-full flex-wrap items-start justify-between gap-6">
            <Aspiration.Requirements />
            <Aspiration.Actions />
          </div>
          <div className="h-full w-full">
            <Aspiration.Grid setShowForm={setShowForm} />
          </div>
        </>
      ) : (
        <AspirationForm setShowForm={setShowForm} />
      )}
    </Aspiration.Root>
  );
};
